import { CardHeader, CardHeaderProps, styled } from '@mui/material'

type Props = CardHeaderProps & {
  title: string
}

export const TabHeader = ({ title, ...props }: Props) => <StyledCardHeader title={title} {...props} />

const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  '& .MuiCardHeader-title': {
    color: theme.palette.primary.main,
  },
}))

export default TabHeader

export type { Props as TabHeaderProps }
